// filepath: /Users/probe/git/hrm-corp/ecoya-export-bos-web/src/store/apis/baseQuerySetup.ts
import i18n from "@/src/i18n";
import PUBLIC_PATH from "@/src/routes/public/path";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {
  BaseQueryFn,
  fetchBaseQuery,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";
import qs from "qs";
import { getPersistorInstance } from "../persistorInstance";
import ERROR_CODE from "./errorCode";

export const QUERY_TIME_OUT = 60000;
export const X_TIMEZONE_HEADER = "X-Timezone";

export const unAuthLogic = () => {
  const persistor = getPersistorInstance();
  if (persistor) {
    persistor.purge();
  }
  window.history.replaceState("", "", PUBLIC_PATH.LOGIN);
};

export interface MinimalStateWithAuthToken {
  auth: {
    token: string | null;
  };
}

export const createBaseQueryFn = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as MinimalStateWithAuthToken).auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("accept-language", i18n.language);

      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (userTimezone) {
        headers.set(X_TIMEZONE_HEADER, userTimezone);
      }

      return headers;
    },
    timeout: QUERY_TIME_OUT,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });

const mainApiBaseQuery = createBaseQueryFn(process.env.REACT_APP_API_URL || "");

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result: QueryReturnValue<any, FetchBaseQueryError, FetchBaseQueryMeta> =
    await mainApiBaseQuery(args, api, extraOptions);

  if (result.error) {
    const errorData: any = result.error.data;
    ERROR_CODE.includes(errorData?.errorCode) && unAuthLogic();
  }
  return result;
};

export const tagTypes = [
  "auth",
  "additional-infos",
  "buyerEmployees",
  "buyer",
  "buyers",
  "factoryEmployees",
  "warehouses",
  "workplace",
  "SendbirdUser",
  "SendbirdToken",
  "SendbirdUnreadCount",
] as const;
